// Élaument cart cross-sell action.
// Adds a product to the cart (data-add-id) and, when a swap is needed,
// removes a line item (data-remove-key). Then sends the shopper to the cart so
// they see the result. First-party only: no external requests beyond Shopify's
// own cart endpoints.

function elaumentCartAction(event) {
  const btn = event.target.closest('[data-cro-cart-add]');
  if (!btn) return;
  event.preventDefault();
  if (btn.dataset.busy === '1') return;
  btn.dataset.busy = '1';
  btn.setAttribute('disabled', '');

  const addId = Number(btn.getAttribute('data-add-id'));
  const removeKey = btn.getAttribute('data-remove-key');

  (async () => {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: addId, quantity: 1 }] }),
      });
      if (removeKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: removeKey, quantity: 0 }),
        });
      }
      window.location.href = '/cart';
    } catch (err) {
      btn.removeAttribute('disabled');
      delete btn.dataset.busy;
      console.error('Élaument cart action failed', err);
    }
  })();
}

if (!window.__elaumentCartActionBound) {
  window.__elaumentCartActionBound = true;
  document.addEventListener('click', elaumentCartAction);
}
